import Contract from './index'

import Management from './management'
import TypeManagement from './TypeManagement'
import UserTypeManagement from './UserTypeManagement'

export default {
  path: '/home/activity',
  component: Contract,
  meta: { titie: '福利中心' },
  children: [
    {
      path: '/home/activity/management',
      meta: { titie: '任务管理' },
      component: Management,
    },
    {
      path: '/home/activity/typeManagement',
      meta: { titie: '任务类型管理' },
      component: TypeManagement,
    },
    {
      path: '/home/activity/userTypeManagement',
      meta: { titie: '用户类型管理' },
      component: UserTypeManagement,
    },
  ],
}
